/**
 * React-query hook for the read-only MARC catalog (CZNA-305 E3).
 *
 * The catalog is an immutable classpath resource (changes only on deploy), so
 * it is cached aggressively. Closure-captures `ky` (per MEMORY: useOkapiKy
 * returns an unstable instance and must NOT go into dependency arrays).
 */
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchMarcCatalog } from '../api/marcCatalogService';
export var useMarcCatalog = function () {
    var ky = useOkapiKy();
    return useQuery(['marc-catalog'], function () { return fetchMarcCatalog(ky); }, {
        staleTime: 60 * 60 * 1000,
        cacheTime: 120 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
export default useMarcCatalog;
